export const LOG_TARGET_NAMES = {
  user: "Usuário",
  product: "Produto",
  store: "Loja",
  gradablemodel: "Modelo",
  serial: "Serial",
  coupon: "Cupom",
};

export function logTargetLabel(target) {
  return LOG_TARGET_NAMES[target] ?? target ?? "-";
}
